import React from "react";
import { useQuery } from "@apollo/client/react";
import { ASSET_QUERY, GROUPED_ASSET_QUERY } from "../../../constants/graphql";
import AssetDetailsModal from "./AssetDetailsModal";
import KitDetailsModal from "./KitDetailsModal";
import GroupedAssetDetailsModal from "./GroupedAssetDetailsModal";
export default function ItemIdAssetModal({
  id,
  asset: assetFromProps = null,
  onClose,
  narrow = false,
  footerActions = null,
}) {
  const knownAssetType = assetFromProps?.type;
  const { data: { asset: initialAsset } = {}, loading: initialLoading } = useQuery(ASSET_QUERY, {
    variables: { id },
  });
  const resolvedInitialAsset = initialAsset || assetFromProps;
  const resolvedAssetType = initialAsset?.type || knownAssetType;
  const { data: { asset: groupedAsset } = {}, loading: groupedLoading } = useQuery(
    GROUPED_ASSET_QUERY,
    {
      variables: { id },
      skip: resolvedAssetType !== "GroupedAsset",
    }
  );
  const asset = resolvedAssetType === "GroupedAsset" ? groupedAsset || resolvedInitialAsset : resolvedInitialAsset;
  const loading = resolvedAssetType === "GroupedAsset" ? groupedLoading : initialLoading;

  switch (resolvedAssetType) {
    case "Asset":
      return (
        <AssetDetailsModal
          asset={asset}
          loading={loading}
          onClose={onClose}
          narrow={narrow}
          footerActions={footerActions}
        />
      );
    case "Kit":
      return <KitDetailsModal asset={asset} loading={loading} onClose={onClose} />;
    case "GroupedAsset":
      return (
        <GroupedAssetDetailsModal
          asset={asset}
          loading={loading}
          onClose={onClose}
          readOnlyQuantityCalculation
        />
      );
    default:
      return null;
  }
}
